// Shared tracking doc for strategy reference https://docs.google.com/document/d/1Ta9pY94upQps6_a7GkYlFyVULqZ_RvLgtl91uCjNlK8/edit

// User selects service type
export const trackType = (service) => {
    window.dataLayer.push({
        event: 'bookingType',
        service
    });
};

// User selects location
export const trackLocation = (location) => {
    window.dataLayer.push({
        event: 'bookingLocation',
        location
    });
};

// When a user selects a date and time for their appointment and clicks the continue button format -> date: '2014-03-01', time: '10.00am'
export const trackSelection = (date, time) => {
    window.dataLayer.push({
        event: 'bookingTime',
        date,
        time
    });
};

// When a user changes step
export const trackStep = (step) => {
    window.dataLayer.push({
        event: 'bookingStep',
        step
    });
};

// When a user submits the final form
export const trackSubmission = (date, time, location, service) => {
    window.dataLayer.push({
        event: 'bookingSubmit',
        date,
        time,
        location,
        service
    });
};
